module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.lists), function(list, i) {
    return _c('div', {
      key: i
    }, [_c('drop', {
      staticClass: "drop list",
      on: {
        "drop": function($event) {
          var i = arguments.length, argsArray = Array(i);
          while ( i-- ) argsArray[i] = arguments[i];

          _vm.handleDrop.apply(void 0, [ list ].concat( argsArray ))
        }
      }
    }, _vm._l((list), function(item) {
      return _c('drag', {
        key: item,
        staticClass: "drag",
        class: ( _obj = {}, _obj[item] = true, _obj ),
        attrs: {
          "transfer-data": {
            item: item,
            list: list,
            example: 'lists'
          }
        }
      }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item) + "\n\t\t\t")])
      var _obj;
    }))], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-727d74d9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Lists.vue
// module id = 50
// module chunks = 0